<template>
  <sui-page>
    <sui-page-header :pageId="contextPageId" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_LOGIN_ID')" />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model="queryData.loginId"
              @keyup.enter="onSearchClick"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_USR_NM')" />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model="queryData.userName"
              @keyup.enter="onSearchClick"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_EPNO')" />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model="queryData.employeeIDNumber"
              @keyup.enter="onSearchClick"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_USR_GLBL_NM')" />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model="queryData.userGlobalName"
              @keyup.enter="onSearchClick"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_USR_IRSD_STT_CD')" />
          </div>
          <div class="col-xs-5">
            <sui-code-select ref="codeServedStateCode" :selected="code.servedStateCode" codeId="COD_IRSD_STT"/>
          </div>
        </div>
        <div class="btn_wrap">
          <sui-button
            type="button"
            class="comm_btn_Reset"
            @click="onResetClick"
          >
            {{ $t("MSG_BTN_RESET") }}
          </sui-button>
          <sui-button
            type="button"
            class="comm_btn_Scr"
            @click="onSearchClick"
          >
            {{ $t("MSG_BTN_SRCH") }}
          </sui-button>
        </div>
      </div>
      <div class="mrB30" />
      <sui-grid
        ref="gridUserMaster"
        :columns="columnUserMaster"
        :dataset="'dsUserMaster'"
        :showDisplayCountControl="true"
        :initial-pagesize="10"
      >
        <div class="btn_wrapR">
          <sui-button
            type="button"
            class="comm_btn_gridTop comm_ico_excel"
            @click="onExcelDownloadClick"
          >
            {{ $t('MSG_BTN_EXCEL_DOWN') }}
          </sui-button>
        </div>
      </sui-grid>
      <div class="comm_btn_wrap">
        <sui-button
          type="button"
          class="comm_btn_border"
          @click="onModifyClick"
        >
          {{ $t('MSG_BTN_MDFC') }}
        </sui-button>
        <sui-button
          type="button"
          class="comm_btn_border"
          @click="onDeleteClick"
        >
          {{ $t('MSG_BTN_DEL') }}
        </sui-button>
        <sui-button
          type="button"
          class="comm_btn_solid"
          @click="onRegistClick"
        >
          {{ $t('MSG_BTN_RGST') }}
        </sui-button>
      </div>
    </sui-page-contents>
  </sui-page>
</template>

<script>
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMY_00033', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  data() {
    return {
      queryData: {
        loginId: '',
        userName: '',
        employeeIDNumber: '',
        userGlobalName: '',
      },
      code: {
        careerLevelCode: { key: '', label: '' },
        userTypeCode: { key: '', label: '' },
        userBelongingTypeCode: { key: '', label: '' },
        servedStateCode: { key: '', label: '' },
      },
      columnUserMaster: [{
        text: this.$t('MSG_TXT_USR_ID'),
        datafield: 'userId',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
            handler: this.onDetailClick,
            type: 'link',
          }, this.dsUserMaster, this.$refs.gridUserMaster);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_LOGIN_ID'),
        datafield: 'loginId',

      }, {
        text: this.$t('MSG_TXT_EPID'),
        datafield: 'epid',

      }, {
        text: this.$t('MSG_TXT_EPNO'),
        datafield: 'employeeIDNumber',
      },
      {
        text: this.$t('MSG_TXT_KNOX_ID'),
        datafield: 'knoxId',

      }, {
        text: this.$t('MSG_TXT_USR_NM'),
        datafield: 'userName',
      }, {
        text: this.$t('MSG_TXT_USR_GLBL_NM'),
        datafield: 'userGlobalName',

      },
      {
        text: this.$t('MSG_TXT_EMAIL'),
        datafield: 'email',
      },
      {
        text: this.$t('MSG_TXT_CPNY_NM'),
        datafield: 'companyName',

      }],
    };
  },
  computed: {},
  watch: {},
  datasets: [{
    id: 'dsUserMaster',
    type: 'local',
    datafields: [
      {
        name: 'userId',
        type: 'string',
        map: 'userId',
      },
      {
        name: 'loginId',
        type: 'string',
        map: 'loginId',
      },
      {
        name: 'epid',
        type: 'string',
        map: 'epid',
      },
      {
        name: 'employeeIDNumber',
        type: 'string',
        map: 'employeeIDNumber',
      },
      {
        name: 'knoxId',
        type: 'string',
        map: 'knoxId',
      },
      {
        name: 'userName',
        type: 'string',
        map: 'userName',
      },
      {
        name: 'userGlobalName',
        type: 'string',
        map: 'userGlobalName',
      },
      {
        name: 'email',
        type: 'string',
        map: 'email',
      },
      {
        name: 'companyName',
        type: 'string',
        map: 'companyName',
      },
    ],
  }],
  mounted() {
    this.$nextTick(() => {
      this.onLoad();
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    onLoad() {
      const paramData = utils.getParameter(this, 'queryData');
      if (!utils.isEmpty(paramData)) {
        this.queryData = paramData;
        this.onSearchClick();
      }
    },
    onSearchClick() {
      const dataParams = {
        loginId: this.queryData.loginId,
        userName: this.queryData.userName,
        employeeIDNumber: this.queryData.employeeIDNumber,
        userGlobalName: this.queryData.userGlobalName,
        servedStateCode: this.code.servedStateCode.key,
      };
      http.requestTest('get', '/api/v1/common/user-master', {
        query: dataParams,
      }).then(res => {
        this.dsUserMaster.setRawData(res.data);
        this.code.careerLevelCode.key = this.objUserMaster.careerLevelCode;
        this.code.userTypeCode.key = this.objUserMaster.userTypeCode;
        this.code.userBelongingTypeCode.key = this.objUserMaster.userBelongingTypeCode;
        this.code.servedStateCode.key = this.objUserMaster.servedStateCode;
      });
    },
    onResetClick() {
      this.queryData.loginId = '';
      this.queryData.userName = '';
      this.queryData.employeeIDNumber = '';
      this.queryData.userGlobalName = '';
      this.$refs.codeServedStateCode.reset();
    },
    onRegistClick() {
      utils.goPage('PGE_CMY_00034', {
        queryData: this.queryData,
      });
    },
    onModifyClick() {
      const selectedRow = this.dsUserMaster.getSelectedRow();
      if (selectedRow) {
        utils.goPage('PGE_CMY_00035', {
          userId: selectedRow.userId,
          queryData: this.queryData,
        });
      } else {
        utils.messageBox('warning', this.$t('MSG_ALT_NOT_SEL_ITEM'));
      }
    },
    onDetailClick(btn, selectedRow) {
      if (selectedRow) {
        utils.goPage('PGE_CMY_00036', {
          userId: selectedRow.userId,
          queryData: this.queryData,
        });
      }
    },
    onDeleteClick() {
      const selectedRow = this.dsUserMaster.getSelectedRow();
      if (selectedRow) {
        const { userId } = selectedRow;
        utils.messageBox('confirm', this.$t('MSG_ALT_WANT_DEL'), null, () => {
          http.requestTest('delete', `/api/v1/common/user-master/${userId}`, {
          // http.request(this.contextPageId, "DTS_XXX_XXXXX", {
            path: { 'user-id': userId },
          }).then(() => {
            utils.messageBox('success', this.$t('MSG_ALT_DELETED'));
            this.onSearchClick();
          });
        });
      } else {
        utils.messageBox('warning', this.$t('MSG_ALT_NOT_SEL_ITEM'));
      }
    },
    onExcelDownloadClick() {
      const sPageId = this.contextPageId;
      const objGridColumns = this.columnUserMaster;
      const objGridDataset = this.dsUserMaster;
      const sToday = utils.now('YYYYMMDDHHmmss');
      const sExcelName = `excel_${sToday}.xlsx`;
      utils.downloadGridToExcel(sPageId, objGridColumns, objGridDataset, sExcelName, {});
    },

  },
};
</script>

<style scoped>
</style>
